// import { Experiment } from 'storefront-nuxt-ab-testing'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type { Experiment } from '../modules/ab-testing/experiment'
import { isTrackedExperiment } from '../modules/ab-testing/trackedExperiments'

const useExperimentTracking = () => {
  const { ssrContext } = useNuxtApp()
  const req = ssrContext?.event.node?.req
  const route = useRoute()
  const { trackTriggerExperiment } = useTrackingEvents()

  const activeExperiments = useState<Experiment[]>(
    'activeExperiments',
    () => [],
  )

  if (import.meta.server && !activeExperiments.value.length) {
    activeExperiments.value =
      ((req as any).experiments as Experiment[])?.filter((i) => i.valid) || []
  }

  const triggerEvents = () => {
    for (const experiment of activeExperiments.value || []) {
      // ECOM-2761: only the keep-listed experiments emit `experiment_triggered`.
      // Every other active experiment is iterated but skipped, so registration,
      // variant assignment, and feature gating stay untouched.
      if (!isTrackedExperiment(experiment.name)) {
        continue
      }
      trackTriggerExperiment({
        experiment_name: experiment.name,
        experiment_variant: experiment.selectedVariant || '',
      })
    }
  }

  onMounted(triggerEvents)
  watch(() => route.fullPath, triggerEvents)
}

export default useExperimentTracking
